import { updateImageAction } from 'editor/src/store/gallery/slice';
import { MimeType } from 'editor/src/store/gallery/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import detectImageTransparency from 'editor/src/util/detectImageTransparency';

/**
 * Detects if an image has transparent background and updates the gallery state.
 * Only runs analysis if not already detected.
 * Skips SVG files as they are vector-based and don't need transparency detection.
 */
const detectImageTransparencyOperation =
  (imageId: string) => async (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const image = state.gallery.images.find((img) => img.id === imageId);

    // Skip if image not found, no URL, SVG type, or already analyzed
    if (!image || !image.url || image.type === MimeType.SVG || image.hasTransparentBackground !== undefined) {
      return;
    }

    try {
      const hasTransparency = await detectImageTransparency(image.url);
      dispatch(updateImageAction({ id: imageId, hasTransparentBackground: hasTransparency }));
    } catch {
      // Silently fail - leave hasTransparentBackground as undefined
    }
  };

export default detectImageTransparencyOperation;
